import { useEffect, useMemo } from "react";
import { useBeatPlayer } from "../audio";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";
import SiteFooter from "../components/SiteFooter";
import ContestCard from "../contests/ContestCard";
import { useContests, type WebContest } from "../contests/data";

const title = "Ovalord Radio · BeatFlipz";
const ovalordHost = "ovalord";

function isOvalordHost(name?: string): boolean {
  return (name ?? "").toLowerCase() === ovalordHost;
}

function ovalordRooms(contests: WebContest[]): WebContest[] {
  return contests.filter((c) => isOvalordHost(c.host_username));
}

export default function Ovalord() {
  const { state } = useContests();
  const reducedMotion = usePrefersReducedMotion();
  const player = useBeatPlayer();
  const rooms = useMemo(
    () => (state.status === "ready" ? ovalordRooms(state.contests) : []),
    [state],
  );

  useEffect(() => {
    document.title = title;
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-ground font-sans text-chrome antialiased">
      <main className="px-4 pb-20 pt-24 md:px-6 md:pb-28 md:pt-32">
        <div className="mx-auto w-full max-w-[1240px]">
          <header className="border-b border-ground-edge pb-8 md:pb-10">
            <p className="text-[11px] uppercase tracking-[0.24em] text-chrome-dim">Ovalord Radio</p>
            <h1 className="mt-3 font-headline text-4xl uppercase leading-[0.95] tracking-[-0.02em] text-chrome md:text-6xl">
              Ovalord Radio
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-chrome-dim">
              Live beat reactions on the show. Rooms on BeatFlipz when a contest is actually open.
            </p>
            <p className="mt-3 text-[11px] uppercase tracking-[0.14em] text-chrome-dim">
              Reaction $10 · two beats $20
            </p>
          </header>

          {rooms.length > 0 && (
            <section data-testid="ovalord-rooms" className="mt-10" aria-label="Rooms">
              <h2 className="font-headline text-2xl uppercase tracking-[-0.02em] text-chrome">Rooms</h2>
              <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                {rooms.map((contest) => (
                  <ContestCard key={contest.slug} contest={contest} player={player} reducedMotion={reducedMotion} />
                ))}
              </div>
            </section>
          )}
        </div>
      </main>
      {player.elements}
      <SiteFooter />
    </div>
  );
}
